<template>
  <div
    ref="modalRef"
    id="media-library-tabs"
    :style="{
      position: 'fixed',
      background: 'rgba(50, 50, 50, 0.8)',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
      zIndex: 1000,
      overflow: 'hidden',
      color: 'white',
      top: '0vh',
      left: '50vw',
      height: '100vh',
      width: '50vw',
    }"
  >
    <div class="modal-header">
      <h5>Alerce Search Module</h5>
    </div>

    <div class="modal-body" v-show="!isMinimized">
      <!-- Pestañas -->
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            :class="{ active: activeTab === 'videos' }"
            @click="activeTab = 'videos'"
            type="button"
            role="tab"
          >
            <i class="bi bi-camera-video"></i> Videos
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            :class="{ active: activeTab === 'images' }"
            @click="activeTab = 'images'"
            type="button"
            role="tab"
          >
            <i class="bi bi-image"></i> Images
          </button>
        </li>
      </ul>

      <!-- Contenido de las pestañas -->
      <div class="tab-content">
        <div 
          v-show="activeTab === 'videos'" 
          class="tab-pane" 
          :class="{ active: activeTab === 'videos', show: activeTab === 'videos' }"
          role="tabpanel"
        >
          <search-videos
            v-if="activeTab === 'videos'"
            :modal-id="'search-videos'"
            :is-visible="true"
            @close="closeDialog"
            @video-selected="handleVideoSelected"
            @minimize="handleMinimize"
            @restore="handleRestore"
          />
        </div>
        <div 
          v-show="activeTab === 'images'" 
          class="tab-pane" 
          :class="{ active: activeTab === 'images', show: activeTab === 'images' }"
          role="tabpanel"
        >
          <search-images
            v-if="activeTab === 'images'"
            :modal-id="'search-images'"
            :is-visible="true"
            @close="closeDialog"
            @image-selected="handleImageSelected"
            @minimize="handleMinimize"
            @restore="handleRestore"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import SearchVideos from './SearchVideos.vue'
import SearchImages from './SearchImages.vue'

const props = defineProps({
  modalId: { type: String, default: 'media-library-tabs' },
  isVisible: { type: Boolean, required: true }
})

const emit = defineEmits<{
  (event: 'closed'): void
  (event: 'videoSelected', coordinates: number[]): void
  (event: 'imageSelected', coordinates: number[]): void
  (event: 'minimize', modalId: string): void
  (event: 'restore', modalId: string): void
}>()

const modalRef = ref<HTMLElement | null>(null)
const isMinimized = ref(false)
const activeTab = ref<'videos' | 'images'>('videos')

defineExpose({
  isMinimized,
  restoreModal
})

function restoreModal() {
  console.log('Restaurando modal:', props.modalId)
  isMinimized.value = false
  emit('restore', props.modalId)
}

function closeDialog() {
  emit('closed')
}

function handleVideoSelected(coordinates: number[]) {
  emit('videoSelected', coordinates)
}

function handleImageSelected(coordinates: number[]) {
  emit('imageSelected', coordinates)
}

function handleMinimize() {
  isMinimized.value = true
  emit('minimize', props.modalId)
}

function handleRestore() {
  isMinimized.value = false
  emit('restore', props.modalId)
}
</script>

<style scoped>
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: rgba(40, 40, 40, 0.95);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.modal-header h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}

.header-actions {
  display: flex;
  gap: 8px;
}

.btn-close-modal {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-close-modal:hover {
  background: rgba(255, 255, 255, 0.2);
}

.modal-body {
  height: calc(100vh - 60px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.nav-tabs {
  background: rgba(40, 40, 40, 0.8);
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  padding: 0 8px;
  margin: 0;
  flex-shrink: 0;
}

.nav-item {
  margin-bottom: -2px;
}

.nav-link {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  padding: 6px 16px;
  cursor: pointer;
  transition: all 0.2s;
  border-bottom: 2px solid transparent;
  font-size: 13px;
}

.nav-link:hover {
  color: rgba(255, 255, 255, 0.9);
  background: rgba(255, 255, 255, 0.05);
}

.nav-link.active {
  color: white;
  background: rgba(255, 255, 255, 0.1);
  border-bottom-color: #5ba1df;
  font-weight: 600;
}

.nav-link i {
  margin-right: 4px;
  font-size: 12px;
}

.tab-content {
  flex: 1;
  overflow: hidden;
  background: transparent;
}

.tab-pane {
  height: 100%;
  overflow: hidden;
  display: none !important;
}

/* Sobrescribir el estilo global que oculta los tab-pane */
.tab-pane.active,
.tab-pane.show {
  display: block !important;
}

/* Ocultar el header de los componentes hijos para evitar duplicación */
.tab-pane :deep(.modal-header) {
  display: none;
}

/* Ajustar el body de los componentes hijos */
.tab-pane :deep(.modal-body) {
  height: 100%;
  padding: 0;
}
</style>
